module.exports = __webpack_public_path__ + "static/Capacity_Header_BG_new-7e807fa2d8e7cfed46339c23db2585f2.mp4";